import script from "./DetailsContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsContainer.vue?vue&type=script&setup=true&lang=js"

import "./DetailsContainer.vue?vue&type=style&index=0&id=2e72e97a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e72e97a"]])

export default __exports__